import { InterfacePage, type Props } from './InterfacePage';
import { InterfacePrintLayout } from './InterfacePrintLayout/InterfacePrintLayout';

export default function WebInterface(props: Props) {
  return (
    <InterfacePrintLayout>
      <InterfacePage {...props} />
    </InterfacePrintLayout>
  );
}
